import { Injectable } from '@angular/core';

declare let THREE: any;

@Injectable()
export class WallCutService {
  private plane = new THREE.Plane();

  private buildPlane(normal, planePoint, vec?) {
    const plane = this.plane;

    plane.setFromNormalAndCoplanarPoint(normal, planePoint);

    if (vec) {
      vec.set(plane.normal.x, plane.normal.y, plane.normal.z, plane.constant);
      return vec;
    } else {
      return new THREE.Vector4(plane.normal.x, plane.normal.y, plane.normal.z, plane.constant);
    }
  }

  cutHoles(wall) {
    wall.updateMatrixWorld();

    let i = 0,
      child,
      childPosition,
      entity;
    const wallChildren = wall.children.filter(c => c && (c.name === 'Window' || c.name === 'Door'));
    const innerPlaneMaterial = wall.material[4];
    const outerPlaneMaterial = wall.material[5];
    const planes = [];
    const existedPlanes = innerPlaneMaterial.cutPlanes;
    let existedPlaneIndex = 0;

    for (; i < wallChildren.length; i++) {
      child = wallChildren[i];
      childPosition = child.position.clone().negate();
      entity = child.userData.entity;

      planes.push(
        this.buildPlane(
          new THREE.Vector3(-1, 0, 0),
          childPosition.clone().add(new THREE.Vector3(-entity.length / 2, 0, 0)),
          existedPlanes[existedPlaneIndex++]
        )
      );

      planes.push(
        this.buildPlane(
          new THREE.Vector3(1, 0, 0),
          childPosition.clone().add(new THREE.Vector3(entity.length / 2, 0, 0)),
          existedPlanes[existedPlaneIndex++]
        )
      );

      planes.push(
        this.buildPlane(
          new THREE.Vector3(0, -1, 0),
          childPosition.clone().add(new THREE.Vector3(0, -entity.height / 2, 0)),
          existedPlanes[existedPlaneIndex++]
        )
      );

      planes.push(
        this.buildPlane(
          new THREE.Vector3(0, 1, 0),
          childPosition.clone().add(new THREE.Vector3(0, entity.height / 2, 0)),
          existedPlanes[existedPlaneIndex++]
        )
      );
    }

    innerPlaneMaterial.cutPlanes = planes;
    outerPlaneMaterial.cutPlanes = planes;

    innerPlaneMaterial.needsUpdate = true;
    outerPlaneMaterial.needsUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/wall/wall-cut.service.ts